// extracted by mini-css-extract-plugin
module.exports = {"card-slider":"testimonials-component-module--card-slider--637j3","cardSlider":"testimonials-component-module--card-slider--637j3"};